<template>
	<div class="forgot-password-container">
		<div class="forgot-password-title">
			<button @click="returnToSignIn()"><img src="@/common/assets/images/icon-left.webp" alt="back"></button>
			<h2>Forgot Password</h2>
		</div>

		<form class="forgot-password-form" @submit="(event) => handleSubmit(event)">
			<span class="forgot-password-info">
				Enter the email address associated with your account and we will send you a new password
			</span>

			<div class="forgot-password-form-content">
				<label for="email">Email:</label>
				<input
					type="email"
					id="email"
					name="email"
					placeholder="Enter your email"
					v-model="formData.username"
					autocomplete="email"
					required
					@focusout="FORM_VALIDATOR?.validateFormField('username')"
					:class="[{'error-border' : !FORM_VALIDATOR?.isFieldValid('username')}]"
				>
			</div>

			<div class="form-bottom">
				<span class="error" v-for="(error, index) in FORM_VALIDATOR?.errors()"
							:key="index">{{ error.fieldCondition.message }}
				</span>
				<input
					:class="['forgot-password-button', {'not-allowed' : !FORM_VALIDATOR?.isFormValid() || !formData.username}]"
					type="submit"
					value="CONTINUE"
				>
			</div>

		</form>
	</div>
</template>

<script>
import {FormValidator} from "@/common/services/FormValidator";
import * as PASSWORD_GENERATION_SERVICE from "@/common/services/password-generation-service";
import * as COMMON_SERVICE from "@/common/services/common-request-service";
import {NOTIFICATION_TYPE} from "@/common/utils/constants";
import {setUser} from "@/common/services/common-request-service";
import axios from "axios";

export default {
	name: "ForgotPassword",
	data() {
		return {
			formData: {
				username: null
			},
			fieldsConditions: {
				username: {
					isRequired: {
						value: true,
						message: "The email is required."
					},
					pattern: {
						value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
						message: "The email does not match the required format."
					}
				}
			},
			FORM_VALIDATOR: null
		}
	},
	mounted() {
		this.FORM_VALIDATOR = new FormValidator(this.formData, this.fieldsConditions);
	},
	methods: {
		returnToSignIn() {
			this.$router.push(`/sign-in`)
		},
		getEmailData(data) {
			let url = `${window.location.host}/reset-password/${data.uri}`;
			url = url.includes('localhost') ? `http://${url}` : url;

			return {
				to: {
					emails: [this.formData.username]
				},
				title: 'DRC Password Reset',
				isDRC: true,
				message: `<div>
										Hello,</br></br>
										Your new DRC Guest account’s password is: <span style="color: orangered">${data.password}</span></br></br>
										Please have it confirmed by clicking here: <a style="text-decoration: underline; color: blue; cursor: pointer" href="${url}">${url}</a>.</br></br>
										This link will expire in 15 minutes.</br></br>
										<p style="color: #FDC030;"><b>Akkodis DRC Team</b></p>
									</div>`
			}
		},
		sendConfirmationEmail(token) {
			const data = PASSWORD_GENERATION_SERVICE.getResetPasswordData(token);
			axios.defaults.headers.common['Forgot-Password'] = `${token}`;
			COMMON_SERVICE.sendEmail(this.getEmailData(data))
				.then(() => {
					this.$router.push(`/forgot-password/confirmation`)
				})
				.catch((error) => {
					console.error(error);
					this.showNotification("Failed to send an email.", NOTIFICATION_TYPE.ERROR);
				})
				.finally(() => {
					axios.defaults.headers.common['Forgot-Password'] = null;
				});
		},
		handleSubmit(event) {
			event.preventDefault();
			this.FORM_VALIDATOR.validateFormFields();

			if (this.FORM_VALIDATOR.isFormValid() && this.formData.username) {
				this.$loader.show({
					text: '',
					description: '',
					buttonText: null,
					isBlue: false,
					onCancel: () => {
					}
				});

				COMMON_SERVICE.forgotPassword(this.formData.username)
					.then((response) => {
						const token = response.data;
						if (token) {
							this.sendConfirmationEmail(token);
						}
					})
					.catch((error) => {
						console.error(error);
						this.showNotification(this.$t('formsNotifications.somethingWentWrong'), NOTIFICATION_TYPE.ERROR);
					})
					.finally(() => {
						setTimeout(() => {
							this.$loader.hide();
						}, 600);
					});
			}
		},
	}
}
</script>

<style lang="scss" scoped>
@import '@/common/assets/css/_variables.scss';

.forgot-password-container {
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100%;
	width: 80%;
	gap: 20px;

	@media (max-width: $tablet) {
		width: 100%;
		max-width: 480px;
		height: unset;
		padding: 0;
		margin: unset;
		gap: 30px;
	}

	.forgot-password-title {
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		gap: 20px;
		max-width: 480px;
		width: 100%;
		min-width: 250px;

		@media (max-width: $mobile) {
			min-width: unset;
		}

		button {
			width: 40px;
			height: 40px;
			padding: 8px;
			gap: 8px;
			cursor: pointer;
			background-color: #001929;
			border: 1px solid transparent;
			border-radius: 4px;

			&:hover {
				border: 1px solid #EBEBF52E;
			}
		}

		h2 {
			margin: 0;
			font-family: Tiempos Headline, serif;
			font-size: 24px;
			font-weight: 500;
			line-height: 34px;
			letter-spacing: 0.360px;
			text-align: left;
		}
	}

	.forgot-password-form {
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		gap: 15px;

		.forgot-password-form-content {
			display: flex;
			flex-direction: column;
			gap: 2px;

			label {
				font-family: Roboto, serif;
				font-size: 10px;
				font-weight: 400;
				line-height: 16px;
				text-align: left;
				color: #FCFCFE;
				text-transform: uppercase;
			}

			input {
				border: 2px solid #E5E5EA;
				gap: 12px;
				padding: 10px 12px;
				font-family: Roboto, serif;
				font-size: 15px;
				font-weight: 400;

				&.error-border {
					border: 2px solid rgba(201, 32, 40, 1);
				}

				&:focus {
					border: 2px solid;
					border-image: linear-gradient(234.31deg, #FFB81C 6.55%, #00FFFF 99.58%) 1;
					outline: none;
				}
			}
		}

		.form-bottom {
			display: flex;
			flex-direction: column;
			justify-content: center;

			.error {
				position: relative;
				color: red;
				font-size: 12px;
			}

			.forgot-password-button {
				background-color: $color-hover-button;
				min-height: 48px;
				padding: 10px 18px;
				gap: 12px;
				font-family: Roboto, serif;
				font-size: 17px;
				font-weight: 400;
				line-height: 22px;
				text-align: center;
				cursor: pointer;
				margin-top: 20px;
				margin-bottom: 20px;
				border: none;

				&.not-allowed {
					cursor: not-allowed;
				}

				// suggestion:
				background-image: linear-gradient(234.31deg, #FFB81C 6.55%, #00FFFF 99.58%);
				background-size: 100%;
				background-position: center;
				transition: background-size 0.5s ease, background-position 0.5s ease;

				&:hover {
					background-image: linear-gradient(234.31deg, #FFB81C 6.55%, #00FFFF 99.58%);
					background-size: 200%;
					background-position: right;
					box-shadow: 0 2px 3px rgba(255, 184, 28, 0.4)
				}
			}
		}

	}
}
</style>
